// extracted by mini-css-extract-plugin
export default {"wrapperPage":"Services_wrapperPage__2-I8Q","title":"Services_title__P7yYk","content":"Services_content__BKz3f"};